/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ rate: NonNullable<unknown>, unit: NonNullable<unknown> }} Seo_Rate_UnitInputs */

const en_seo_rate_unit = /** @type {(inputs: Seo_Rate_UnitInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.rate} per 1,000 ${i?.unit}`)
};

const zh_hans1_seo_rate_unit = /** @type {(inputs: Seo_Rate_UnitInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`每千个 ${i?.unit} ${i?.rate}`)
};

const pt_br2_seo_rate_unit = /** @type {(inputs: Seo_Rate_UnitInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.rate} por mil ${i?.unit}`)
};

const es_seo_rate_unit = /** @type {(inputs: Seo_Rate_UnitInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.rate} por cada 1,000 ${i?.unit}`)
};

const fr_seo_rate_unit = /** @type {(inputs: Seo_Rate_UnitInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.rate} pour 1 000 ${i?.unit}`)
};

const de_seo_rate_unit = /** @type {(inputs: Seo_Rate_UnitInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.rate} pro 1.000 ${i?.unit}`)
};

const ru_seo_rate_unit = /** @type {(inputs: Seo_Rate_UnitInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.rate} за 1000: ${i?.unit}`)
};

const it_seo_rate_unit = /** @type {(inputs: Seo_Rate_UnitInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.rate} ogni 1.000 ${i?.unit}`)
};

/**
* | output |
* | --- |
* | "{rate} per 1,000 {unit}" |
*
* @param {Seo_Rate_UnitInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const seo_rate_unit = /** @type {((inputs: Seo_Rate_UnitInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seo_Rate_UnitInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_seo_rate_unit(inputs)
	if (locale === "pt-BR") return pt_br2_seo_rate_unit(inputs)
	if (locale === "es") return es_seo_rate_unit(inputs)
	if (locale === "fr") return fr_seo_rate_unit(inputs)
	if (locale === "de") return de_seo_rate_unit(inputs)
	if (locale === "ru") return ru_seo_rate_unit(inputs)
	if (locale === "it") return it_seo_rate_unit(inputs)
	return en_seo_rate_unit(inputs)
});